import { createStyles } from "@mantine/core"

export const useStyles = createStyles((theme) => ({
    container: {
        width: "100%",
        "&:nth-of-type(2n)": {
            backgroundColor: theme.colors.gray[0],
        },
    },
    formStep: {
        flexDirection: "column",
        width: "100%",
        maxWidth: "var(--form-main-content-max-width)",
        padding: "1rem 1.5rem",
        gap: "1rem",
        marginLeft: "auto",
        marginRight: "auto",

        "&:nth-of-type(2n)": {
            backgroundColor: theme.colors.gray[0],
        },

        [theme.fn.largerThan("xs")]: {
            padding: "2rem 1.5rem",
            gap: "1.5rem",
        },

        [theme.fn.largerThan("md")]: {
            flexDirection: "row",
            justifyContent: "space-between",
            padding: "2.5rem 0",
            gap: "2.5rem",
        },
    },
    indexSection: {
        alignItems: "center",
        textAlign: "center",

        [theme.fn.largerThan("md")]: {
            padding: "0",
            flexDirection: "column",
            gap: "1rem",
            flex: 1,
            maxWidth: "116px",
        },
    },
    number: {
        borderRadius: "50%",
        color: "white",
        fontSize: "24px",
        fontWeight: 500,
        backgroundColor: theme.fn.primaryColor(),
        width: "40px",
        height: "40px",

        [theme.fn.largerThan("md")]: {
            width: "60px",
            height: "60px",
        },
    },
    contentSection: {
        flex: 3,
    },
    title: {
        "&.mantine-Title-root": {
            marginLeft: "1rem",
            [theme.fn.largerThan("md")]: {
                margin: 0,
            },
        },
    },
}))
